// import DefaultLegacyImport from '@elliemae/ds-legacy-filterbar';
// export { DSFilterBar, DSFilterBarWithSchema } from '@elliemae/ds-legacy-filterbar';
// export default DefaultLegacyImport;
export * from '@elliemae/ds-legacy-filterbar';
